import authProvider from './authProvider';
import DataProvider from './dataProvider';
import i18nProvider from './i18nProvider';

export { authProvider, DataProvider, i18nProvider};